import { useState, useEffect } from "react";
import AppHeader from "./components/AppHeader";
import Categories from "./pages/Categories";
import Quizzes from "./pages/Quizzes";
import QuizPlayer from "./components/QuizPlayer";
import AppBackground from "./components/AppBackground";
import { Container, CircularProgress, Box } from "@mui/material";
import { api, setUnauthorizedHandler } from "./api";
import LoginPage from "./pages/Login";
import { signOut, getCurrentUser } from "aws-amplify/auth";

export default function App() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authReady, setAuthReady] = useState(false);

  // 🔐 Vérification session Cognito AU DÉMARRAGE
  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();     // ✅ session valide
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false); // ❌ pas connecté
      } finally {
        setAuthReady(true);
      }
    };

    checkAuth();
  }, []);

  // 🚨 Handler 401 API
  useEffect(() => {
    setUnauthorizedHandler(async () => {
      await signOut();
      setIsAuthenticated(false);
      setSelectedCategory(null);
      setActiveQuiz(null);
    });
  }, []);

  const handleStartTraining = async (quizId) => {
    const quiz = await api.getQuiz(quizId);
    setActiveQuiz(quiz);
  };

  const handleFinishQuiz = () => {
    setActiveQuiz(null);
  };

  // ⏳ Attente vérification auth
  if (!authReady) {
    return (
      <AppBackground>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
          <CircularProgress />
        </Box>
      </AppBackground>
    );
  }

  return (
    <AppBackground>
      <AppHeader />

      <Container maxWidth="lg" sx={{ py: 6 }}>
        {!isAuthenticated ? (
          <LoginPage onLoginSuccess={() => setIsAuthenticated(true)} />
        ) : (
          <>
            {!selectedCategory && (
              <Categories onSelectCategory={setSelectedCategory} />
            )}

            {selectedCategory && !activeQuiz && (
              <Quizzes
                category={selectedCategory}
                onStartTraining={handleStartTraining}
              />
            )}

            {activeQuiz && (
              <QuizPlayer
                quiz={activeQuiz}
                onFinish={handleFinishQuiz}
              />
            )}
          </>
        )}
      </Container>
    </AppBackground>
  );
}
